<script lang="ts">
  import type { Bookmark } from "./bookmarks";
  import { bookmarkExists, bookmarkLabel, bookmarks, removeBookmark } from "./state.svelte";
  import { len } from "./util";

  interface Props {
    // the folder that can be added or removed, none in the Home View
    currBookmark?: Bookmark;
    dismiss: () => void;
    addtobookmarks?: () => void;
    gotobookmark: (b: Bookmark) => void;
  }

  let { currBookmark, dismiss, addtobookmarks, gotobookmark }: Props = $props();

  let inBookmarks = $derived(currBookmark ? bookmarkExists(currBookmark) : false);

  function addToBookmarks() {
    addtobookmarks?.();
    dismiss();
  }

  function goToBookmark(b: Bookmark) {
    gotobookmark(b);
    dismiss();
  }

  function removeCurrentBookmark() {
    if (currBookmark) {
      removeBookmark(currBookmark);
    }
    dismiss();
  }
</script>

<div
  class="absolute flex flex-col bg-white px-2 py-2 border border-gray-300 shadow-md cursor-pointer top-[100%] left-0 text-sm text-black max-h-[85vh] w-max max-w-[42vw] overflow-auto z-20"
>
  {#if !currBookmark}
    {#if len(bookmarks) == 0}
      <div class="px-2 py-0.5 text-gray-500 cursor-default">No bookmarks yet</div>
    {/if}
  {:else if inBookmarks}
    <button
      class="flex hover:bg-gray-200 truncate px-2 py-0.5 min-h-[1.5rem] text-red-500"
      onclick={removeCurrentBookmark}
    >
      Remove this folder from bookmarks
    </button>
  {:else}
    <button class="flex hover:bg-gray-200 truncate px-2 py-0.5 min-h-[1.5rem]" onclick={addToBookmarks}>
      Bookmark this folder
    </button>
  {/if}

  {#if len(bookmarks) > 0 && currBookmark}
    <hr class="mt-2 mb-2 py-0.5" />
  {/if}
  {#each bookmarks as b}
    <button class="flex hover:bg-gray-200 truncate px-2 py-0.5 min-h-[1.5rem] shrink-0" onclick={() => goToBookmark(b)}>
      {bookmarkLabel(b)}
    </button>
  {/each}
</div>
